<div class="app-container">
  <div class="header-section">
    <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
            <h2 class="text-primary mb-2 fw-bold"></h2>
        </div>
        <div class="d-flex justify-content-end">
            <a (click)="openCreateModal()" 
               class="btn btn-sm fw-bold btn-primary"
               *ngIf="!areAllWebhooksCreated()">
                Add Webhook
            </a>
        </div>
    </div>
  </div>

  <app-data-table
    [data]="webhooks"
    [columns]="tableColumns"
    [isLoading]="isLoading"
    [emptyMessage]="'No webhooks configured yet. Click the button above to create one.'"
    [showActions]="true"
    [showEditButton]="true"
    [showToggleButton]="true"
    [showDeleteButton]="true"
    [isTogglingId]="isToggling"
    [stateField]="'state'"
    [successStateValue]="'ACTIVE'"
    (onEdit)="editWebhook($event)"
    (onToggle)="toggleWebhook($event)"
    (onDelete)="deleteWebhook($event)">
  </app-data-table>
</div> 